import {
  CountryFlag,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@aircall/ds";
import type { ComponentProps } from "react";

import type { LineWithFlagTypes } from "./LineWithFlag.decl";

type CountryIsoCode = ComponentProps<typeof CountryFlag>["countryIsoCode"];

/**
 *
 * @param {string} name - Line name to display
 * @param {string} countryISO - Country ISO code ie: "US"
 * @param {string} phoneNumber - phone number of the line
 * @returns {JSX.Element} - Flex component with flag and line name next to it
 */
export const LineWithFlag = ({
  name,
  countryISO,
  phoneNumber,
}: LineWithFlagTypes) => (
  <div className="flex items-center gap-1">
    <div data-test={name}>
      <CountryFlag countryIsoCode={countryISO as CountryIsoCode} size="lg" />
    </div>
    {phoneNumber ? (
      <Tooltip>
        <TooltipTrigger className="truncate capitalize">{name}</TooltipTrigger>
        <TooltipContent>{phoneNumber}</TooltipContent>
      </Tooltip>
    ) : (
      <span className="truncate capitalize">{name}</span>
    )}
  </div>
);
